import { FormattedMessage, injectIntl } from 'react-intl';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import UserForm from '../../user/userForm';
import Modal from 'react-bootstrap/Modal';
import { useQueryClient } from 'react-query';
import AddressModal from '../orders/addressModal';

const AdminRoutePlanDeliveryOrderBatchTable = ({ deliveryOrderBatches }) => {
  const [editAddress, setEditAddress] = useState(null);

  const queryClient = useQueryClient();
  function onAddressEditSuccess() {
    queryClient.invalidateQueries('deliveryOrderBatches');
    setEditAddress(null);
  }

  return (
    <>
      <table className="table table-striped admin__table">
        <thead>
          <tr>
            <th>
              <FormattedMessage id={'admin.route.planning.create.customers.table.customer'} />
            </th>
            <th>
              <FormattedMessage id={'admin.route.planning.create.customers.table.address'} />
            </th>
            <th>
              <FormattedMessage id={'admin.route.planning.create.customers.table.coordinates'} />
            </th>
            <th className="text-right">
              <FormattedMessage id={'admin.route.planning.create.customers.table.actions'} />
            </th>
          </tr>
        </thead>
        <tbody>
          {deliveryOrderBatches.map((dob) => (
            <tr key={dob.id}>
              <td>
                {dob.packingId ? `#${dob.packingId}` : `D${dob.id}`} {dob.address.customerName}
              </td>
              <td>{dob.address.street}</td>
              <td>
                {dob.address.coordinates ? (
                  `${dob.address.coordinates.lat}, ${dob.address.coordinates.lon}`
                ) : (
                  <span style={{ color: 'red' }}>Missing</span>
                )}
              </td>
              <td className="text-right">
                <button onClick={() => setEditAddress(dob.address)} className="btn btn-small btn-normal-link">
                  <FormattedMessage id={'admin.route.planning.create.customers.table.actions.edit.profile'} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={!!editAddress} onHide={() => setEditAddress(null)} size="lg">
        <div onClick={() => setEditAddress(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editAddress ? (
            <AddressModal
              existingAddress={editAddress}
              onSuccess={() => {
                onAddressEditSuccess();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
    </>
  );
};

export default injectIntl(AdminRoutePlanDeliveryOrderBatchTable);
